(function () {
    const saveCollection = {
        init: function () {
            saveCollection.controls();
            saveCollection.collectionName = document.querySelector('#saveSearchDialog [name=saveSearchName]');
            saveCollection.collectionConceptID = document.querySelector('#saveSearchDialog [name=ConceptID]');
        },
        controls: function () {
            document.querySelectorAll('.save_collection').forEach(button => {
                button.addEventListener('click', e => {
                    this.updateFields(e);
                });
            });
        },

        updateFields: function (e) {
            var name = e.currentTarget.getAttribute('collection-title');
            var conceptID = e.currentTarget.getAttribute('conceptID');
            var activeActions = document.querySelector('.issue-item__footer__actions.active');
            if (activeActions) {
                activeActions.classList.remove('active');
            }
            e.currentTarget.parentNode.classList.add('active');
            saveCollection.collectionName.value = name;
            saveCollection.collectionConceptID.value = conceptID;
        },
    };

    UX.saveCollection = saveCollection;
})();
